import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import './styles/Fade.css'
import Servicos from './pages/Servicos'
import SobreNos from './pages/SobreNos'
import Valores from './pages/Valores'
import Garantias from './pages/Garantias'
import Clientes from './pages/Clientes'
import Parceiros from './pages/Parceiros'
import ContacteNos from './pages/ContacteNos'
import Cotacoes from './pages/Cotacoes'

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <main>
              <Home />
              <Servicos />
              <SobreNos />
              <Valores />
              <Garantias />
              <Clientes />
              <Parceiros />
              <ContacteNos />
            </main>
          }
        />
        <Route
          path="/cotacoes"
          element={
            <main>
              <Cotacoes />
            </main>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  )
}